import { ref } from "vue";

export default {
  mounted(element) {
    const isUsingKeyboard = ref(false);

    const handleKeydown = (event) => {
      if (event.key === "Tab" || (event.shiftKey && event.key === "Tab")) {
        isUsingKeyboard.value = true;
      }
    };

    const handleMousedown = () => {
      isUsingKeyboard.value = false;
    };

    const handleFocus = () => {
      if (isUsingKeyboard.value) {
        element.classList.add("focus-visible");
      }
    };

    const handleBlur = () => {
      element.classList.remove("focus-visible");
    };

    document.addEventListener("keydown", handleKeydown);
    document.addEventListener("mousedown", handleMousedown);
    element.addEventListener("focus", handleFocus);
    element.addEventListener("blur", handleBlur);

    element._removeFocusListeners = () => {
      document.removeEventListener("keydown", handleKeydown);
      document.removeEventListener("mousedown", handleMousedown);
      element.removeEventListener("focus", handleFocus);
      element.removeEventListener("blur", handleBlur);
    };
  },
  unmounted(element) {
    if (element._removeFocusListeners) {
      element._removeFocusListeners();
      delete element._removeFocusListeners;
    }
  },
};
